import React, { Fragment, useEffect } from "react";
import { useSnackbar } from 'notistack';

const Toast = ({ message, type, timer }) => {

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    
      if(timer){
        closeSnackbar();
      } else {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: null
        });
      }
  
    }, []);

  return (
    <>
    </>
  )
}

export default Toast;